import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "justify-center d-flex" }
const _hoisted_3 = { class: "weight" }
const _hoisted_4 = { class: "input-ground" }
const _hoisted_5 = {
  key: 0,
  class: "text-center",
  style: {"margin-top":"40px"}
}
const _hoisted_6 = { class: "table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("span", null, _toDisplayString($setup.kg), 1),
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "unit" }, "KG", -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "输入身高获取BMI（单位cm）",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.height) = $event))
      }, null, 512), [
        [_vModelText, $setup.height]
      ]),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.getBMI && $setup.getBMI(...args)))
      }, " 查看 ")
    ]),
    ($setup.bmi && $setup.bmi !== Infinity)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 当前BMI指数为 " + _toDisplayString($setup.bmi), 1))
      : _createCommentVNode("", true),
    _createElementVNode("table", _hoisted_6, [
      _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", { colspan: "4" }, "成年人身体质量指数")
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("th", null, "过瘦"),
          _createElementVNode("th", null, "正常"),
          _createElementVNode("th", null, "过重"),
          _createElementVNode("th", null, "肥胖")
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.BMI_LIST, (item, index) => {
            return (_openBlock(), _createElementBlock("td", {
              key: item,
              class: _normalizeClass({ active: index === $setup.bmiIndex })
            }, _toDisplayString(item), 3))
          }), 128))
        ])
      ])
    ])
  ]))
}